<template>
  <DataTable
    data-testid="custom-operations-table"
    class="custom-operations-table"
    :data="items"
    :items-per-page="itemsPerPage"
    :status="status"
    :columns="columns"
    has-interaction
    @on-row-click="handleOnRowClick"
  >
    <template #empty>
      <HelperViewContextual
        class="custom-operations-table__helper"
        icon="BB0040"
        description="Você não possui ativos no filtro selecionado"
      />
    </template>
  </DataTable>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { DataTable, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import { CustomOperationPosition } from '@/modules/trade/services/instruments/types';

interface Props {
  isLoading: boolean;
  itemsPerPage: number;
  items: CustomOperationPosition[];
}
const props = defineProps<Props>();

const router = useRouter();

const status = computed(() => (props.isLoading ? 'loading' : 'default'));

const handleOnRowClick = ({ id }: CustomOperationPosition) => {
  router.push({
    name: 'customOperationDetails',
    params: { id }
  });
};
</script>

<style lang="less" scoped>
.custom-operations-table {
  padding: @size-spacing-x500;
  border: @size-border-x400 solid @divider-primary;
  border-radius: @size-radius-x200;

  ::v-deep th {
    white-space: nowrap;
  }

  ::v-deep td:not(:first-child) {
    white-space: nowrap;
  }

  &__helper {
    padding: @size-spacing-x700 0 @size-spacing-x500 0;
    margin: 0 auto;
  }
}
</style>
